// Written by desktop/scripts/stamp-version.js. Do not edit by hand.
export const VERSION = "0.9.239";
export const BUILT_AT = "3 nov 23:25";
export const BUILT_AT_ISO = "2026-11-03T22:25:34.794Z";
